<script setup>
import DpIcon from "./DpIcon";
</script>
<script>
  export default {
    name: "DpNotificationPersist",
    props: {
      visible: {type: Boolean, default: true},
      type: {type: String, default: 'info'},
      flipIcon: {type: Boolean, default: false},
      title: {type: String},
      message: {type: String, default: undefined},
      fullWidthMessage: {type: Boolean, default: false}
    },
    data() {
      return {
        icon: {
          'danger': 'close',
          'error': 'close',
          'warning': 'close',
          'success': 'check',
          'info': 'info'
        },
      };
    },
    computed: {
      hasTitle() {
        return this.title || this.$slots.title;
      }
    }
  }
</script>

<template>
  <DpExpand>
    <div v-show="visible"
         :class="[
        'dp-notification-persist',
        'dp-flex',
        'column',
        `dp-color__background__${type}`,
        `dp-color__font__${type}`,
        (!hasTitle) ? 'compact' : ''
      ]">
      <div class="dp-flex row justify-content__flex-start">
        <div class="dp-notification-persist__icon flex-basis-0" :class="{'compact': !hasTitle}">
          <DpIcon :icon="icon[type]" :class="{'flip-icon': flipIcon}" />
        </div>
        <div class="dp-flex column justify-content__flex-start flex-grow-1">
          <div v-if="hasTitle" class="dp-notification-persist__title">
            <slot name="title">{{title}}</slot>
          </div>
          <div v-if="!fullWidthMessage" class="dp-notification-persist__content">
            <slot>{{message}}</slot>
          </div>
          <div v-if="!fullWidthMessage && hasTitle && $slots.controls" class="dp-notification-persist__controls">
            <slot name="controls"></slot>
          </div>
        </div>
      </div>
      <div v-if="fullWidthMessage" class="dp-notification-persist__content full-width">
        <slot>{{message}}</slot>
      </div>
      <div v-if="fullWidthMessage && hasTitle && $slots.controls" class="dp-notification-persist__controls full-width">
        <slot name="controls"></slot>
      </div>
    </div>
  </DpExpand>
</template>

<style scoped lang="scss">
  .dp-notification-persist {
    border-radius: 8px;
    padding: .5em;
    margin: 1em 0;

    &.compact {
      padding: 0;
      margin: 0.5em 0;

      .dp-notification-persist__icon {
        font-size: 1rem;
        padding: .45rem 1rem;
      }
    }

    .dp-notification-persist__icon {
      padding: .8rem 1.1rem;
      font-size: 2rem;
    }

    .dp-notification-persist__title {
      font-size: 1.45em;
      padding-top: .5rem;
      padding-inline-end: 1rem;
      padding-bottom: 0;
      padding-inline-start: 0;
    }

    .dp-notification-persist__content,
    .dp-notification-persist__controls {
      padding-top: .5rem;
      padding-inline-end: 1rem;
      padding-bottom: .5rem;
      padding-inline-start: 0;

      &.full-width {
        padding: .5rem 1rem;
      }
    }

    .dp-notification-persist__controls {
      text-align: end;
    }
  }
</style>

<i18n>
  {}
</i18n>

